<!-- eslint-disable -->
<template>
  <div :class="P_customClass" :style="C_buttonContainerStyle">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <button 
      v-show="C_isVisible"
      :style="C_buttonStyle" 
      :class="{active: C_isActiveState}"
      :disabled="isTrue(P_disabled) || P_editing"
      @mousedown="eventMouseDown(P_buttonId, P_makeSingleEvent, C_isPowerButton)"
      @mouseup="eventMouseRelease(P_buttonId, P_makeSingleEvent, C_isPowerButton)"
      @click="eventMouseClick(P_buttonId, P_makeSingleEvent, C_isPowerButton)">
      <div :style="C_iconStyle" class="icon-container"><i :class="C_className"></i></div>
      <div v-if="P_textPlacement === 'inner' || P_textPlacement === ''" :style="C_textStyle" class="text-container">{{P_buttonText}}</div>
    </button>
    <div v-if="P_textPlacement === 'outer'" :style="C_textStyle" class="text-container">{{P_buttonText}}</div>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: [
    'P_buttonText',
    'P_buttonWidth',
    'P_buttonHeight',
    'P_buttonColor',
    'P_buttonPadding',
    'P_fontColor',
    'P_fontSize',
    'P_fontWeight',
    'P_iconName',
    'P_inactiveIcon',
    'P_iconColor',
    'P_iconSize',
    'P_flexDirection',
    'P_textPlacement',
    'P_buttonId',
    'P_makeSingleEvent',
    'P_customCss'
  ],
  data () {
    return {
      DV_shutdownButton: true
    }
  },
  mixins: [bi10GridComponent],
  computed: {
    C_buttonContainerStyle() {
      const CI = this
      const additionalStyles = {}
      
      additionalStyles['height'] = CI.P_buttonHeight || "100%"
      additionalStyles['width'] = CI.P_buttonWidth || "100%"

      return additionalStyles;
    },
    C_isPowerButton() {
      return this.P_iconName && this.P_iconName.toLowerCase().includes("power");
    },
    C_buttonStyle() {
      const CI = this
      const additionalStyles = {}
      if (CI.P_buttonColor) additionalStyles['background'] = CI.P_buttonColor
      if (CI.P_buttonPadding) additionalStyles['padding'] = CI.P_buttonPadding
      if (CI.P_flexDirection) additionalStyles['flex-direction'] = CI.P_flexDirection
      return additionalStyles
    },
    C_iconStyle () {
      const CI = this
      const additionalStyles = {}
      if (CI.P_iconColor) additionalStyles['color'] = CI.P_iconColor
      if (CI.P_iconSize) additionalStyles['font-size'] = CI.P_iconSize
      return additionalStyles
    },
    C_textStyle () {
      const CI = this
      const additionalStyles = {}
      if (CI.P_fontColor) additionalStyles['color'] = CI.P_fontColor
      if (CI.P_fontSize) additionalStyles['font-size'] = CI.P_fontSize
      if (CI.P_fontWeight) additionalStyles['font-weight'] = CI.P_fontWeight
      return additionalStyles
    },
    C_className () {
      const CI = this

      if (CI.P_iconName.includes('far') || CI.P_iconName.includes('fas')) { 

        if (CI.C_isActiveState == false && CI.P_inactiveIcon) return CI.P_inactiveIcon

        return CI.P_iconName 
      }

      if (CI.C_isActiveState == false && CI.P_inactiveIcon) return `fas fa-${CI.P_inactiveIcon}`

      return `fas fa-${CI.P_iconName}`
    }
  },
}
</script>
<style lang="less" scoped>
button {
  background: #AFAFAF;
  border: 1px solid black;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
  cursor: pointer;
  &:active {
    background: #93bac7 !important;
  }
  &.active {
    background: #93bac7 !important;
  }
  &:focus {
    outline: 0;
  }
  div {
    margin: auto;
    &.text-container {
      color: black;
      font-size: .8rem;
      margin: 0;
      align-self: center;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/GButtonWithIcon.vue